import PropTypes from 'prop-types'
import React from 'react'

export default function CloseSession({ styles }) {
  return (
    <svg
      width="22"
      style={styles}
      height="22"
      viewBox="0 0 22 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.0625 11.6425H10.3125V14.2433L14.5379 10.8629L10.3125 7.48242V10.0839H2.0625V11.6425Z"
        fill="currentColor"
      />
      <path
        d="M17.7464 16.6004C19.2789 15.0679 20.1231 13.0302 20.1231 10.8632C20.1231 8.70031 19.2816 6.666 17.754 5.13425L17.745 5.126C16.9902 4.36631 16.1054 3.773 15.116 3.36325C14.1329 2.95625 13.0955 2.75 12.0319 2.75H11.9865C10.9237 2.75 9.88555 2.95625 8.90311 3.36325C7.95574 3.75581 7.10392 4.31613 6.37036 5.02975L7.47242 6.1325C8.69824 4.9555 10.307 4.30856 12.0092 4.30856C13.7596 4.30856 15.4055 4.99056 16.6437 6.22875C17.8825 7.46763 18.5639 9.1135 18.5639 10.8639C18.5639 12.6143 17.8825 14.2601 16.6437 15.4983C15.4055 16.7372 13.7596 17.4185 12.0092 17.4185C10.307 17.4185 8.69892 16.7716 7.47242 15.5953L6.37036 16.6973C7.88974 18.1686 9.88967 18.9778 12.0092 18.9778C14.1762 18.9771 16.214 18.1328 17.7464 16.6004Z"
        fill="currentColor"
      />
    </svg>
  )
}

CloseSession.propTypes = {
  styles: PropTypes.any,
}
